module.exports = __webpack_public_path__ + "static/media/pulse-un.9d46e6e8.svg";